// Import Section
import block_icons from '../icons/advace_column_child';
import color_palette_list from '../gb-helper/color_palette';

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls, MediaUpload, MediaUploadCheck, InnerBlocks } = wp.blockEditor;
const { PanelBody, PanelRow, SelectControl, Dashicon, RangeControl, ColorIndicator, ColorPalette, Button, __experimentalGradientPicker } = wp.components;
const ALLOWED_BLOCKS = ['core/columns'];
import './parent';

registerBlockType('blocksbakery/advanced-column', {
    title: __('columns', 'blocks-bakery'),
    description: __(
        'The advanced column block allows to insert many number of columns in a single row. This is an advanced option with customization ease to manage the look of this block on the page with different advanced shape dividers and many more.',
        'blocks-bakery'
    ),
    // common, formatting, layout, widgets, embed
    category: 'blocks_bakery',
    icon: block_icons.advace_child_icon,
    parent: ['blocksbakery/advanced-columns'],
    keywords: [
        __('advance', 'blocks-bakery'),
        __('columns', 'blocks-bakery')
    ],

    supports: {
        html: false
    },
    attributes: {
        // layout
        width_child_content: {
            type: "number",
        },
        // Spacing
        top_padding_child: {
            type: 'number',
        },
        gradient_bg: {
            type: 'string'
        },
        bottom_padding_child: {
            type: 'number',
        },
        left_padding_child: {
            type: 'number',
            default: 20
        },
        right_padding_child: {
            type: 'number',
            default: 20
        },
        bg_color_child: {
            type: "string"
        },
        top_margin_child: {
            type: 'number',
            default: 30
        },
        bottom_margin_child: {
            type: 'number',
            default: 30
        },
        left_margin_child: {
            type: 'number',
            default: 30
        },
        bg_color_opacity_child: {
            type: "number",
            default: 1
        },
        right_margin_child: {
            type: 'number',
            default: 30
        },
        // Background Setting
        background_setting: {
            type: 'string',
            source: 'text',
            default: 'None'
        },
        color_opacity: {
            type: 'number',
            default: 100,
        },
        bg_color: {
            type: 'string',
        },
        select_gg: {
            type: 'string',
            default: 'none'
        },
        gradient_selector_child: {
            type: "string",
            default: "linear-gradient"
        },
        color1_child: {
            type: 'string',
        },
        color2_child: {
            type: 'string',
        },
        location1_child: {
            type: "number",
            default: 40
        },
        location2_child: {
            type: "number",
            default: 70
        },
        angle_child: {
            type: "number",
            default: 180
        },
        color_gradient_opacity: {
            type: 'number',
            default: 100
        },
        img_ID_child: {
            type: 'number'
        },
        img_URL_child: {
            type: 'string',
            default: undefined
        },
        img_alt_child: {
            type: 'string',
            source: 'attribute',
            attribute: 'alt',
            selector: 'img'
        },
        imgbgposition_child: {
            type: "string",
            default: "center"
        },
        bgimgattachment_child: {
            type: "string",
            default: "fixed"
        },
        bgimgrepeat_child: {
            type: "string",
            default: "no-repeat"
        },
        bgimgsize_child: {
            type: "string",
            default: "cover"
        },
        // border
        select_border_child: {
            type: 'html',
            default: 'dotted'
        },
        border_radius_child: {
            type: 'number',
            default:10,
        },
        border_width_child: {
            type: 'number',
            default: 1,
        },
        border_color_child: {
            type: 'string',
        },
        save_background_child: { 
            type: 'string',
            default: "linear-gradient"
        },
        bg_selctor_type_img_child: {
            type: "string"
        },
        bg_selctor_type_child: {
            type: "string"
        },
        opacity_value: {
            type: 'string',
            default: 'FF'
        },
        pd_pxper:{
            type: "string",
            default: 'px',
        },
        mar_pxper:{
            type: "string",
            default: 'px',
        }
    },
    edit: (props) => {
        const select_img_child = (img) => {
            props.setAttributes({
                img_ID_child: img.id,
                img_URL_child: img.url,
                img_alt_child: img.alt
            })
        };
        const remove_img_child = () => {
            props.setAttributes({
                img_ID_child: null,
                img_URL_child: 'undefined',
                img_alt_child: null
            })
        };

        const hexConverter = (val) => {
            val = Math.round(val * 100) / 100;
            var alpha = Math.round(val * 255);
            var hex = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
            props.setAttributes({ opacity_value: hex })
        }
        const p_px = () => {
            var x = document.getElementById("p_px");
            var y = document.getElementById("p_per");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({ pd_pxper: "px" })
        }
        const p_per = () => {
            var x = document.getElementById("p_px");
            var y = document.getElementById("p_per");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({ pd_pxper: "%" })
        }

        const m_px = () => {
            var x = document.getElementById("m_px");
            var y = document.getElementById("m_per");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({ mar_pxper: "px" })
        }
        const m_per = () => {
            var x = document.getElementById("m_px");
            var y = document.getElementById("m_per");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({ mar_pxper: "%" })
        }
        return (
            <React.Fragment>
                <InspectorControls>
                    <PanelBody title={__('Layout', 'blocks-bakery')} initialOpen={false}>
                        <RangeControl
                            label={__('Content Width (%)', 'blocks-bakery')}
                            min={0}
                            max={100}
                            initialPosition={100}
                            value={props.attributes.width_child_content}
                            onChange={(new_val) => {
                                props.setAttributes({ width_child_content: new_val })
                            }} />
                    </PanelBody>
                    <PanelBody title={__('Spacing', 'blocks-bakery')} initialOpen={false}>
                    <PanelRow>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ marginRight: 82 }}>Padding</p>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span> <Dashicon icon="desktop" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span><Dashicon icon="tablet" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span><Dashicon icon="phone" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button onClick={p_px} id="p_px" style={{ fontSize: 12, marginTop: "9px", paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                <Button onClick={p_per} id="p_per" style={{ fontSize: 10, marginTop: "10px", padding: 0 }}><span style={{ height: 30 }}>%</span></Button>
                            </div>
                        </PanelRow>
                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.984h-14c-1.103 0-2 0.897-2 2v0.797h18v-0.797c0-1.103-0.897-2-2-2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    initialPosition={20}
                                    value={props.attributes.top_padding_child}
                                    onChange={(new_val) => {
                                        props.setAttributes({ top_padding_child: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ top_padding_child: 20 })
                                }}> Reset
                            </Button>
                        </div>
                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.656 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M3 19.016h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.103 0.897 2 2 2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.bottom_padding_child}
                                    initialPosition={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bottom_padding_child: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ bottom_padding_child: 20 })
                                }}> Reset
                            </Button>
                        </div>
                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.656 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M0.984 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.left_padding_child}
                                    initialPosition={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ left_padding_child: new_val })
                                    }} />

                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ left_padding_child: 20 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.015 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.104 0 2-0.896 2-2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.right_padding_child}
                                    initialPosition={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ right_padding_child: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ right_padding_child: 20 })
                                }}> Reset
                            </Button>
                        </div>


                        <hr />
                        <PanelRow>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ marginRight: 82 }}>Margin</p>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span> <Dashicon icon="desktop" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span><Dashicon icon="tablet" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 14, backgroundColor: "#e4e5e5", color: "#23282d", }}>
                                    <span><Dashicon icon="phone" style={{ fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center" }} /></span></Button>
                                <Button onClick={m_px} id="m_px" style={{ fontSize: 12, marginTop: "9px", paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                <Button onClick={m_per} id="m_per" style={{ fontSize: 10, marginTop: "10px", padding: 0 }}><span style={{ height: 30 }}>%</span></Button>
                            </div>
                        </PanelRow>
                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.984h-14c-1.103 0-2 0.897-2 2v0.797h18v-0.797c0-1.103-0.897-2-2-2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    initialPosition={0}
                                    value={props.attributes.top_margin_child}
                                    onChange={(new_val) => {
                                        props.setAttributes({ top_margin_child: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ top_margin_child: 30 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>
 

                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.656 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M3 19.016h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.103 0.897 2 2 2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    value={props.attributes.bottom_margin_child}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bottom_margin_child: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ bottom_margin_child: 30 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.656 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M0.984 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    value={props.attributes.left_margin_child}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ left_margin_child: new_val })
                                    }} />                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ left_margin_child: 20 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.015 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.104 0 2-0.896 2-2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    value={props.attributes.right_margin_child}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ right_margin_child: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ right_margin_child: 30 })
                                }}> Reset
                            </Button>
                        </div>

                    </PanelBody>
                    <PanelBody title={__('Background', 'block-for-editors')} initialOpen={false}>
                        <PanelBody title={__("Background Color", 'blocks-bakery')} initialOpen={false}>
                            <p><span>{__('Background Color', 'blocks-bakery')}
                                <ColorIndicator style={{ backgroundColor: props.attributes.bg_color_child }} /></span></p>
                            <ColorPalette
                                colors={color_palette_list}
                                value={props.attributes.bg_color_child}
                                onChange={(new_val) => {
                                    props.setAttributes({ bg_color_child: new_val })
                                }}
                            />

                                     <Button style={{
                                            background: '#007cba', position:"relative",top:"-28px",left:"174px", border: '1px solid #007cba', fontSize: '12px', width: "24%", height: "30px", color: "#ffffff"
                                        }}
                                            onClick={() => {
                                           var x= document.querySelector(".child_overlay");
                                            x.style.backgroundColor = "transparent"
                                            props.setAttributes({bg_color_child:'transparent'})
                                            }}> Reset
                                        </Button>
                            <RangeControl
                                label={__('Opacity', 'blocks-bakery')}
                                min={0}
                                max={1}
                                value={props.attributes.opacity_value}
                                step={0.01}
                                onChange={(new_val) => {
                                    props.setAttributes({ opacity_value: new_val })
                                    hexConverter(new_val)
                                }}
                            />

                        </PanelBody>
                        <PanelBody title={__("Gradient Color", 'blocks-bakery')} initialOpen={false}>
                            <__experimentalGradientPicker
                                value={props.attributes.gradient_bg}
                                onChange={(new_val) => {
                                    props.setAttributes({ gradient_bg: new_val })
                                    // props.setAttributes({bg_color:null})  
                                    // props.setAttributes({
                                    //     img_ID: null,
                                    //     img_URL: null,
                                    //     img_alt: null
                                    // })
                                }} />
                        </PanelBody>
                        <PanelBody title={__("Image or video", 'blocks-bakery')} initialOpen={false}>
                            {props.attributes.img_ID_child ? (
                                <div className="image-ctr">
                                    <img src={props.attributes.img_URL_child}
                                        alt={props.attributes.img_alt_child} />
                                    {props.isSelected ? (
                                        <Button className="btn-remove" onClick={remove_img_child}>
                                            <Dashicon icon='no' size='20' />
                                        </Button>
                                    ) : null}
                                </div>
                            ) : (
                                <MediaUploadCheck>
                                    <MediaUpload
                                        allowedType={['image']}
                                        value={props.attributes.img_ID_child}
                                        onSelect={select_img_child}
                                        render={({ open }) => (
                                            <Button className={"button button-large"} onClick={open}>
                                                {__('Upload Image/Video', 'blocks-bakery')}
                                            </Button>
                                        )}></MediaUpload>
                                </MediaUploadCheck>
                            )}
                            <SelectControl
                                label="Image Position"
                                options={[
                                    { label: 'Top Left', value: 'top left' },
                                    { label: 'Top Center', value: 'top center' },
                                    { label: 'Top Right', value: 'top right' },
                                    { label: 'Center Left', value: 'center left' },
                                    { label: 'Center Center', value: 'center' },
                                    { label: 'Center Right', value: 'center right' },
                                    { label: 'Bottom Left', value: 'bottom left' },
                                    { label: 'Bottom Center', value: 'bottom center' },
                                    { label: 'Bottom Right', value: 'bottom right' },
                                ]}
                                value={props.attributes.imgbgposition_child}
                                onChange={(new_val) => {
                                    props.setAttributes({ imgbgposition_child: new_val })
                                }}
                            />
                            <SelectControl
                                label="Attachment"
                                options={[
                                    { label: 'Fixed', value: 'fixed' },
                                    { label: 'Scroll', value: 'scroll' },
                                ]}
                                value={props.attributes.bgimgattachment_child}
                                onChange={(new_val) => {
                                    props.setAttributes({ bgimgattachment_child: new_val })
                                }}
                            />
                            <SelectControl
                                label="Repeat"
                                options={[
                                    { label: 'No Repeat', value: 'no-repeat' },
                                    { label: 'Repeat', value: 'repeat' },
                                    { label: 'Repeat-X', value: 'repeat-x' },
                                    { label: 'Repeat-Y', value: 'repeat-y' },
                                ]}
                                value={props.attributes.bgimgrepeat_child}
                                onChange={(new_val) => {
                                    props.setAttributes({ bgimgrepeat_child: new_val })
                                }}
                            />
                            <SelectControl
                                label="Size"
                                options={[
                                    { label: 'Auto', value: 'auto' },
                                    { label: 'Cover', value: 'cover' },
                                    { label: 'Contain', value: 'contain' },
                                ]}
                                value={props.attributes.bgimgsize_child}
                                onChange={(new_val) => {
                                    props.setAttributes({ bgimgsize_child: new_val })
                                }}
                            />
                            <RangeControl
                                label={__('Opacity', 'blocks-bakery')}
                                min={0}
                                max={1}
                                value={props.attributes.bg_color_opacity_child}
                                step={0.1}
                                initialPosition={1}
                                onChange={(new_val) => {
                                    props.setAttributes({ bg_color_opacity_child: new_val })
                                }}
                            />
                            {/* <Button style={{
                                background: 'lightblue', borderRadius: '5px', width: '100px', display: 'flow-root', fontSize: '18px   '
                            }}
                                onClick={() => {
                                    props.setAttributes({
                                        bg_selctor_type_img_child: `url(${props.attributes.img_URL_child})`,
                                    })
                                }}> Save </Button> */}
                        </PanelBody>
                    </PanelBody>
                    <PanelBody title={__('Border', 'block-for-editors')} initialOpen={false}>
                        <SelectControl
                            label={__('Border Style', 'blocks-bakery')}
                            value={props.attributes.select_border_child}
                            options={[
                                { value: 'none', label: 'None' },
                                { value: 'solid', label: 'Solid' },
                                { value: 'dottod', label: 'Dotted' },
                                { value: 'dashed', label: 'Dashed' },
                                { value: 'double', label: 'Double' },
                                { value: 'groobe', label: 'Groove' },
                                { value: 'inset', label: 'Inset' },
                                { value: 'outset', label: 'Outset' },
                                { value: 'ridge', label: 'Ridge' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ select_border_child: new_val })
                            }}
                        />
                        <div className="range-controler" style={{ display: "flex",justifyContent:"center",alignItems:"center" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                        <RangeControl
                            label={__('Border Width', 'blocks-bakery')}
                            min={0}
                            max={50}
                            value={props.attributes.border_width_child}
                         
                            initialPosition={1}
                            onChange={(new_val) => {
                                props.setAttributes({ border_width_child: new_val })
                            }} />

                                </div>

                            <Button style={{
                                marginTop:12,
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ border_width_child: 1 })
                                }}> Reset
                            </Button>

                        </div>
                {/* Border Radius */}

    <div className="range-controler" style={{ display: "flex",justifyContent:"center",alignItems:"center" }}>


                            <div style={{ marginRight: "10px", width: "100%" }}>
                        <RangeControl
                            label={__('Border Radius', 'blocks-bakery')}
                            min={0}
                            max={1000}
                            value={props.attributes.border_radius_child}
                          
                            initialPosition={447}
                            onChange={(new_val) => {
                                props.setAttributes({ border_radius_child: new_val })
                            }} />
            </div>
                              <Button style={{
                                       marginTop:12,
                                background: 'transparent', border: '1px solid #007cba', fontSize: '12px', width: "22%", height: "30px", padding: "6px", color: "#007cba"
                            }}
                                onClick={() => {

                                    props.setAttributes({ border_radius_child: 10})
                                }}> Reset
                            </Button>

                        </div>
                        <p>Border Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.border_color_child }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            value={props.attributes.border_color_child}
                            onChange={(new_val) => {
                                props.setAttributes({ border_color_child: new_val })
                            }}
                        />
                    </PanelBody>
                </InspectorControls>

                <div className="gb-ad-col-child" id='main_child' style={{
                    borderStyle: props.attributes.select_border_child, borderWidth: props.attributes.border_width_child, borderRadius: props.attributes.border_radius_child,
                    borderColor: props.attributes.border_color_child,
                    width: props.attributes.width_child_content + '%', minWidth: '20%',
                    marginBottom: props.attributes.bottom_margin_child+props.attributes.mar_pxper,
                    marginLeft: props.attributes.left_margin_child+props.attributes.mar_pxper,
                    marginRight: props.attributes.right_margin_child+props.attributes.mar_pxper,
                    marginTop: props.attributes.top_margin_child+props.attributes.mar_pxper,
                    backgroundImage: `url(${props.attributes.img_URL_child})`,
                    backgroundSize: props.attributes.bgimgsize_child, backgroundPosition: props.attributes.imgbgposition_child, backgroundRepeat: props.attributes.bgimgrepeat_child,
                    backgroundAttachment: props.attributes.bgimgattachment_child,

                }}>
                    <div className="child_overlay"
                        style={{
                            display: 'flex', borderRadius: props.attributes.border_radius_child,
                            background: props.attributes.gradient_bg, backgroundColor: props.attributes.bg_color_child + props.attributes.opacity_value,
                            paddingTop: props.attributes.top_padding_child + props.attributes.pd_pxper,
                             paddingBottom: props.attributes.bottom_padding_child  + props.attributes.pd_pxper,
                            paddingLeft: props.attributes.left_padding_child  + props.attributes.pd_pxper,
                            paddingRight: props.attributes.right_padding_child  + props.attributes.pd_pxper,
                        }}
                    >
                        <InnerBlocks className="gb-ad-col-child-inner-block"
                            allowedBlocks={ALLOWED_BLOCKS}
                            template={[
                                ['core/columns'],
                            ]}
                        />
                    </div>
                </div>
            </React.Fragment>
        )

    },

    save: (props) => {
        return (
            <div>
                <div className="gb-ad-col-child" style={{
                    borderStyle: props.attributes.select_border_child, borderWidth: props.attributes.border_width_child, borderRadius: props.attributes.border_radius_child,
                    borderColor: props.attributes.border_color_child,
                    width: props.attributes.width_child_content + '%', minWidth: '20%',
                    marginBottom: props.attributes.bottom_margin_child+props.attributes.mar_pxper,
                    marginLeft: props.attributes.left_margin_child+props.attributes.mar_pxper,
                    marginRight: props.attributes.right_margin_child+props.attributes.mar_pxper,
                    marginTop: props.attributes.top_margin_child+props.attributes.mar_pxper,
                    backgroundImage: `url(${props.attributes.img_URL_child})`,
                    backgroundSize: props.attributes.bgimgsize_child, backgroundPosition: props.attributes.imgbgposition_child, backgroundRepeat: props.attributes.bgimgrepeat_child,
                    backgroundAttachment: props.attributes.bgimgattachment_child,

                    opacity: props.attributes.bg_color_opacity_child
                }}>
                    <div className="child_overlay"
                        style={{
                            display: 'flex', borderRadius: props.attributes.border_radius_child,
                            background: props.attributes.gradient_bg,
                            sbackgroundColor: props.attributes.bg_color_child + props.attributes.opacity_value,
                            paddingTop: props.attributes.top_padding_child + props.attributes.pd_pxper,
                            paddingBottom: props.attributes.bottom_padding_child  + props.attributes.pd_pxper,
                           paddingLeft: props.attributes.left_padding_child  + props.attributes.pd_pxper,
                           paddingRight: props.attributes.right_padding_child  + props.attributes.pd_pxper,
                        }}
                    >
                        <InnerBlocks.Content className="gb-ad-col-child-inner-block" />
                    </div>
                </div>
            </div>
        )
    }
})